import React, { useEffect, useState } from "react";
import { Card, Box, CircularProgress, Typography, Select, MenuItem } from "@mui/material";
import { ResponsiveLine } from "@nivo/line";
import { esignToolApi } from "../../services/esignApi";
import { format } from "date-fns";

const MultiLineChart = () => {
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [period, setPeriod] = useState("Month");
  const statusColors = {
    Completed: "#01b565", // green
    Expired: "#ef4949",   // red
    Pending: "#ffc338"    // orange
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await esignToolApi.lineChartData(period); // response = { message, data, status }

        const rawData = response.data;

        if (!Array.isArray(rawData)) {
          throw new Error("Expected 'data' to be an array");
        }

        const statusMap = {
          Completed: [],
          Expired: [],
          Pending: []
        };

        rawData.forEach(item => {
          const label = format(new Date(item.month), "MMM"); // e.g. "Jul"

          Object.keys(statusMap).forEach(status => {
            statusMap[status].push({
              x: label,
              y: item[status] || 0
            });
          });
        });

        const formatted = Object.entries(statusMap).map(([status, data]) => ({
          id: status,
          data
        }));

        setChartData(formatted);
      } catch (error) {
        console.error("Chart data error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [period]);


  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Card sx={{ boxShadow: "none", borderRadius: "12px" }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ p: "20px" }}>
        <Typography variant="h6" fontWeight={600}>
          eSign Requests
        </Typography>
        <Select size="small" value={period} onChange={(e) => setPeriod(e.target.value)}>
          <MenuItem value="Month">Month</MenuItem>
          {/* <MenuItem value="Week">Week</MenuItem> */}
        </Select>
      </Box>

      <Box height={350} sx={{ position: "relative", }}>
        <Box sx={{ position: "absolute", top: "35%", left: -88, transform: "translateY(-50%) rotate(-90deg)", background: "linear-gradient(108.34deg, rgba(24, 92, 183, 0.06) 11.27%, rgba(197, 6, 12, 0.06) 96.88%)", px: 0, py: "3px", borderRadius: "0 0 18px 18px", fontWeight: 600, fontSize: "12px", color: "#202224", textAlign: "center", whiteSpace: "nowrap", width: "200px", height: "24px" }} >
          COUNT
        </Box>
        <Box sx={{ position: "absolute", bottom: 0, left: "50%", transform: "translateX(-50%)", background: "linear-gradient(108.34deg, rgba(24, 92, 183, 0.06) 11.27%, rgba(197, 6, 12, 0.06) 96.88%)", px: 2, py: 0.5, borderRadius: "18px 18px 0 0", fontWeight: 600, fontSize: "12px", color: "#202224", width: "200px", height: "24px", textAlign: "center" }} >
          {period.toUpperCase()}
        </Box>

        <ResponsiveLine
          data={chartData}
          curve="monotoneX"
          margin={{ top: 40, right: 30, bottom: 50, left: 60 }}
          xScale={{ type: "point" }}
          yScale={{ type: "linear", min: 0, max: "auto", stacked: false }}
          axisBottom={{
            orient: "bottom",
            tickSize: 0,
            tickPadding: 10,
            legend: "",
            legendOffset: 36,
            legendPosition: "middle",
          }}
          axisLeft={{
            orient: "left",
            tickSize: 0,
            tickPadding: 10,
            legend: "",
            legendOffset: -40,
            legendPosition: "middle",
          }}
          colors={({ id }) => statusColors[id]}
          pointSize={8}
          pointColor={{ theme: "background" }}
          pointBorderWidth={2}
          pointBorderColor={{ from: "serieColor" }}
          enableArea={true}
          areaOpacity={0.1}
          enableGridX={false}
          enableGridY={true}
          useMesh={true}
          legends={[
            {
              anchor: "top-right",
              direction: "row",
              justify: false,
              translateX: 0,
              translateY: -40,
              itemWidth: 100,
              itemHeight: 20,
              itemDirection: "left-to-right",
              symbolSize: 10,
              symbolShape: "circle",
              effects: [{ on: "hover", style: { itemBackground: "#eee", itemOpacity: 1 } }],
            },
          ]}
          theme={{
            tooltip: {
              container: {
                background: "#fff",
                color: "#333",
                fontSize: 13,
                borderRadius: "6px",
                boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
              },
            },
          }}
        />
      </Box>
    </Card>
  );
};

export default MultiLineChart;
